// extracted by css-extract-rspack-plugin
export default {"Box":"label-group-module__Box__u10r4X0"};